import Vue from 'vue'
import App from './App.vue'
import * as Sentry from '@sentry/vue'

import './registerServiceWorker'
import router from './router'
import store from './store'

import { ClientJS } from 'clientjs'

import Api from '@/api'
import SrcConfig from 'SrcConfig'

// constants
import {
  SET_FINGERPRINT,
  SET_ACCOUNT,
  SET_WEB_VIEW,
  SET_CLIENT_TYPE
} from '@/constants/store-types'

// libraries
import VueMeta from 'vue-meta'
import BootstrapVue from 'bootstrap-vue'
import 'vazirmatn/misc/Farsi-Digits/Vazirmatn-FD-font-face.css'
import Snotify from 'vue-snotify'
import VAnimateCss from 'v-animate-css'
import VueCookies from 'vue-cookies'
import BrowserDetect from 'vue-browser-detect-plugin'
import VueRouterBackButton from 'vue-router-back-button'
import BrbImagePreview from '@/components/shared/brb-components/brb-image-preview/install.js'

console.info('Driver version:', process.env.PACKAGE_VERSION)

Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(Snotify)
Vue.use(VAnimateCss)
Vue.use(VueCookies)
Vue.use(BrowserDetect)
Vue.use(VueRouterBackButton, { router })
Vue.use(BrbImagePreview)

// plugins
import config from '@/plugins/config'
import i18n from '@/plugins/i18n'
import dir from '@/plugins/dir'
import api from '@/plugins/api'
import globalMixin from '@/plugins/global-mixin'
import messagingCenter from '@/plugins/messaging-center'
import directives from '@/plugins/directives'

Vue.use(config)
Vue.use(dir)
Vue.use(api)
Vue.use(globalMixin)
Vue.use(messagingCenter)
Vue.use(directives)

// components
import brbComponents from '@/components/shared/brb-components'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Object.keys(brbComponents).forEach((componentName) => {
  Vue.component(componentName, brbComponents[componentName])
})

library.add(fas)
library.add(far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

const clientJs = new ClientJS()
const fingerprint = clientJs.getCustomFingerprint(
  clientJs.getBrowserData().ua || 'NO BROWSER UA',
  clientJs.getScreenPrint() || 'NO SCREEN PRINT',
  clientJs.getCPU() || 'NO CPU',
  clientJs.isMobile() ? 'MOBILE' : 'DESKTOP'
)
store.commit(SET_FINGERPRINT, fingerprint)

const isWebView = navigator.userAgent.includes('wv')
store.commit(SET_WEB_VIEW, isWebView)
store.commit(SET_CLIENT_TYPE, isWebView ? 'ADW' : 'WD')

store.dispatch(SET_ACCOUNT, Api(store))

// sentry
if (SrcConfig.sentry) {
  const { dsn, tracePropagationTargets } = SrcConfig.sentry
  Sentry.init({
    Vue,
    dsn,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets,
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: 1.0
  })
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
